export const getRostersLoadingState = state => state.leaguesClassic.rosters.is_pending;

export default getRostersLoadingState;